import React from 'react';
import { SideImage } from '@/components/ui/Banner/SplitBanner/SideImage';
import { SideText } from '@/components/ui/Banner/SplitBanner/SideText';
import { splitBanner } from '@/components/ui/Banner/SplitBanner/styles';

interface ISplitBannerProps extends React.PropsWithChildren {
  backgroundColor: string;
  direction?: 'normal' | 'reverse';
}

const SplitBanner = ({ children, backgroundColor, direction = 'normal' }: ISplitBannerProps) => {
  const { section, container } = splitBanner({ type: direction });
  return (
    <div style={{ backgroundColor }} className={section()}>
      <div className={container()}>{children}</div>
    </div>
  );
};

SplitBanner.Image = SideImage;
SplitBanner.Text = SideText;

export { SplitBanner };
